import React from 'react';
import { MapPinIcon, CalendarIcon, AlertTriangleIcon } from 'lucide-react';
export interface RestaurantCardProps {
  name: string;
  cuisine: string;
  address: string;
  grade: 'A' | 'B' | 'C' | 'F';
  gradeText: string;
  date: string;
  issuesCount?: number;
  issuesText?: string;
}
export function RestaurantCard({
  name,
  cuisine,
  address,
  grade,
  gradeText,
  date,
  issuesCount = 0,
  issuesText
}: RestaurantCardProps) {
  const gradeColors = {
    A: {
      border: 'border-emerald-500',
      bg: 'bg-emerald-100',
      text: 'text-emerald-700',
      badge: 'bg-emerald-50 text-emerald-700 ring-emerald-600/20'
    },
    B: {
      border: 'border-sky-500',
      bg: 'bg-sky-100',
      text: 'text-sky-700',
      badge: 'bg-sky-50 text-sky-700 ring-sky-600/20'
    },
    C: {
      border: 'border-amber-500',
      bg: 'bg-amber-100',
      text: 'text-amber-700',
      badge: 'bg-amber-50 text-amber-700 ring-amber-600/20'
    },
    F: {
      border: 'border-red-500',
      bg: 'bg-red-100',
      text: 'text-red-700',
      badge: 'bg-red-50 text-red-700 ring-red-600/20'
    }
  };
  const colors = gradeColors[grade];
  return <div className={`relative flex flex-col bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden transition-shadow hover:shadow-md w-full max-w-sm my-2`} data-id="element-117">
      {/* Left color accent bar */}
      <div className={`absolute left-0 top-0 bottom-0 w-1.5 ${colors.bg}`} data-id="element-118" />

      <div className="p-4 pl-5" data-id="element-119">
        <div className="flex justify-between items-start mb-2" data-id="element-120">
          <div data-id="element-121">
            <h4 className="font-semibold text-slate-900 leading-tight" data-id="element-122">
              {name}
            </h4>
            <p className="text-sm text-slate-500 mt-0.5" data-id="element-123">{cuisine}</p>
          </div>
          <span className={`inline-flex items-center rounded-md px-2 py-1 text-xs font-medium ring-1 ring-inset ${colors.badge}`} data-id="element-124">
            <span className="font-bold mr-1" data-id="element-125">{grade}</span> | {gradeText}
          </span>
        </div>

        <div className="flex items-center text-sm text-slate-600 mb-3" data-id="element-126">
          <MapPinIcon className="w-4 h-4 mr-1.5 text-slate-400 flex-shrink-0" data-id="element-127" />
          <span className="truncate" data-id="element-128">{address}</span>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-slate-100 text-xs" data-id="element-129">
          <div className="flex items-center text-slate-500" data-id="element-130">
            <CalendarIcon className="w-3.5 h-3.5 mr-1.5 flex-shrink-0" data-id="element-131" />
            Inspected {date}
          </div>

          {issuesCount > 0 && <div className={`flex items-center font-medium ${grade === 'A' ? 'text-amber-600' : colors.text}`} data-id="element-132">
              <AlertTriangleIcon className="w-3.5 h-3.5 mr-1 flex-shrink-0" data-id="element-133" />
              {issuesText || `${issuesCount} issue${issuesCount === 1 ? '' : 's'}`}
            </div>}
        </div>
      </div>
    </div>;
}